import { normalizeSplitBalance } from 'shared/entities/billing';

import { BillingServer, PaymentPromoServer } from './server';
import { IBilling, PaymentCalculateResult } from './client';

export const normalizeBilling = (raw: BillingServer): IBilling => {
  const { balance, legalEntityBalance } = normalizeSplitBalance(
    raw.balance,
    raw.legal_entity_balance
  );

  return {
    balance,
    legalEntityBalance,
    trialUntil: new Date(raw.trial_until),
    tariff: raw.tariff
  };
};

export const normalizeCalculateResult = (
  raw: PaymentPromoServer
): PaymentCalculateResult => ({
  originalPrice: raw.original_price,
  priceToPay: raw.price_to_pay,
  discountPerMonths: raw.discount_per_months
    ? {
        discount: raw.discount_per_months.discount,
        numberOfMonths: raw.discount_per_months.number_of_months
      }
    : null,
  discountForPromocode: raw.discount_for_promocode
});
